/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InvitationContextResponseEnterprise } from './';
import {
    InvitationContextResponseEnterpriseFromJSON,
    InvitationContextResponseEnterpriseFromJSONTyped,
    InvitationContextResponseEnterpriseToJSON,
} from './';
import type { InvitationContextResponseInvitation } from './';
import {
    InvitationContextResponseInvitationFromJSON,
    InvitationContextResponseInvitationFromJSONTyped,
    InvitationContextResponseInvitationToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvitationContextResponse
 */
export interface InvitationContextResponse {
    /**
     * The prismic tag used to get data from prismic
     * @type {string}
     * @memberof InvitationContextResponse
     */
    prismicTag?: string;
    /**
     * Whether the invitation is an organization invitation
     * @type {boolean}
     * @memberof InvitationContextResponse
     */
    organizationView?: boolean;
    /**
     * The id of the default youtube video
     * @type {string}
     * @memberof InvitationContextResponse
     */
    defaultYoutubeVideoID?: string;
    /**
     * The SSO sign-in URL to redirect the user to when the organization has SSO with JIT provisioning enabled. Absent when SSO JIT is not configured.
     * @type {string}
     * @memberof InvitationContextResponse
     */
    ssoJitSignInUrl?: string;
    /**
     * 
     * @type {InvitationContextResponseInvitation}
     * @memberof InvitationContextResponse
     */
    invitation?: InvitationContextResponseInvitation;
    /**
     * 
     * @type {InvitationContextResponseEnterprise}
     * @memberof InvitationContextResponse
     */
    enterprise?: InvitationContextResponseEnterprise;
}

/**
 * Check if a given object implements the InvitationContextResponse interface.
 */
export function instanceOfInvitationContextResponse(value: object): value is InvitationContextResponse {
    return true;
}

export function InvitationContextResponseFromJSON(json: any): InvitationContextResponse {
    return InvitationContextResponseFromJSONTyped(json, false);
}

export function InvitationContextResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'prismicTag': json['prismicTag'] == null ? undefined : json['prismicTag'],
        'organizationView': json['organizationView'] == null ? undefined : json['organizationView'],
        'defaultYoutubeVideoID': json['defaultYoutubeVideoID'] == null ? undefined : json['defaultYoutubeVideoID'],
        'ssoJitSignInUrl': json['ssoJitSignInUrl'] == null ? undefined : json['ssoJitSignInUrl'],
        'invitation': json['invitation'] == null ? undefined : InvitationContextResponseInvitationFromJSON(json['invitation']),
        'enterprise': json['enterprise'] == null ? undefined : InvitationContextResponseEnterpriseFromJSON(json['enterprise']),
    };
}

export function InvitationContextResponseToJSON(value?: InvitationContextResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'prismicTag': value['prismicTag'],
        'organizationView': value['organizationView'],
        'defaultYoutubeVideoID': value['defaultYoutubeVideoID'],
        'ssoJitSignInUrl': value['ssoJitSignInUrl'],
        'invitation': InvitationContextResponseInvitationToJSON(value['invitation']),
        'enterprise': InvitationContextResponseEnterpriseToJSON(value['enterprise']),
    };
}

